// extracted by css-extract-rspack-plugin
export default {"iconsContainer":"icons-container--yMx5uNxzy5o2WQRp"};